<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dokumenty handlowe</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <div v-if="$page.props.can['manage all clients']"> 
          <label class="block text-gray-700">Opiekun:</label>
          <multiselect-input v-model="form.user" class="mt-1 w-full" :options="users" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        </div>
        <label class="pt-4 block text-gray-700">Magazyn:</label>
        <multiselect-input v-model="form.storeroom" :options="storerooms" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        <label class="pt-4 block text-gray-700">Typ:</label>
        <multiselect-input v-model="form.type" :options="types" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        <label class="pt-4 block text-gray-700">Rozliczenie:</label>
        <multiselect-input v-model="form.settlement" :options="settlements" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
      </search-filter>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">Kontrahent</th>
          <th class="px-3 pt-6 pb-4">Numer</th>
          <th class="px-3 pt-6 pb-4">Typ</th>
          <th class="px-3 pt-3 pb-2">Data<br>wystawienia</th>
          <th class="px-3 pt-3 pb-2">Wartość<br>netto/brutto</th>
          <th class="px-3 pt-3 pb-2">Termin<br>płatności</th>
          <th class="px-3 pt-6 pb-4">Pozostało</th>
          <th class="px-3 pt-6 pb-4">Uwagi</th>
          <th class="px-3 pt-6 pb-4">PDF</th>
        </tr>
        <tr v-for="invoice in invoices.data" :key="invoice.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':invoice.nie_rozliczona && invoice.przeterminowana, 'bg-orange-50':invoice.nie_rozliczona && !invoice.przeterminowana}">
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ invoice.kontrahent }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ invoice.numer }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ invoice.sygnatura }} <span class="hidden md:inline">- {{ invoice.typ}}</span>
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ invoice.data_wystawienia }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-end focus:text-shtax-500">
              {{ invoice.netto }} / {{ invoice.brutto }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-end focus:text-shtax-500">
              {{ invoice.termin_platnosci }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-end focus:text-shtax-500">
              {{ invoice.pozostalo }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ invoice.uwagi }}
            </span>
          </td>
          <td class="border-t">
            <a class="px-3 py-2 flex items-center focus:text-shtax-500" :href="invoice.pdf_url" target="_blank">
              <fa icon="file-pdf" size="lg" fixed-width />
            </a>
          </td>
        </tr>
        <tr v-if="invoices.data.length === 0">
          <td class="border-t px-3 py-2" colspan="9">Nie znaleziono faktur.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="invoices.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Dokumenty handlowe' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    MultiselectInput
  },
  layout: Layout,
  props: {
    filters: Object,
    invoices: Object,
    storerooms: Array,
    types: Array,
    users: Array
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        storeroom: this.filters.storeroom,
        type: this.filters.type,
        settlement: this.filters.settlement,
        user: this.filters.user
      },
      settlements: [
        {'id': 0, 'name': 'Nie rozliczone' },
        {'id': 1, 'name': 'Rozliczone częściowo' },
        {'id': 2, 'name': 'Rozliczone całkowicie' }
      ]
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('invoices'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  }
}
</script>
